import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserManagementRoutingModule } from './user-management-routing.module';
import { FormsModule } from '@angular/forms';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserModule } from 'libs/portal/src/modules/home/components/user/user.module';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [UserManagementComponent],
  imports: [CommonModule, FormsModule, CardTableModule, FiltersModule, UserManagementRoutingModule, CardTableModule, UserModule, MatRowComponent, MaterialModule],
})
export class UserManagementModule { }
